import CryptoJS from "crypto-js";
// import {APP_KEY, APP_SECRET, IV, VERSION} from "../constant";


CryptoJS.pad.ZeroPadding = {
    pad: function (data, blockSize) {
        // Shortcut
        var blockSizeBytes = blockSize * 4;

        // Pad
        data.clamp();
        data.sigBytes += blockSizeBytes - ((data.sigBytes % blockSizeBytes) || blockSizeBytes);
    },

    unpad: function (data) {
        // Shortcut
        var dataWords = data.words;

        // Unpad
        var i = data.sigBytes - 1;
        while (!((dataWords[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff)) {
            i--;
        }
        data.sigBytes = i + 1;
    }
}


/**
 * AES加密
 * @param {*} data
 * @param {*} secret
 * @param {*} iv
 * @returns
 */
export function AesEncrypt(data, secret, iv) {
    let key = CryptoJS.enc.Latin1.parse(secret);
    let encrypted = CryptoJS.AES.encrypt(data, key, {
        iv: CryptoJS.enc.Latin1.parse(iv),
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
    });
    return CryptoJS.enc.Hex.parse(encrypted.ciphertext.toString()).toString();
}


/**
 * 字符串转为hex数据
 * @param {String} data
 * @param {*} secret
 * @returns
 */
export function sha256(data, secret) {
    return CryptoJS.enc.Hex.stringify(
        CryptoJS.HmacSHA256(data, secret)
    ).toLowerCase();
}


/**
 * hex数据转为base64编码格式
 * @param {*} str
 * @returns
 */
export function hexString2Bytes(str) {
    let pos = 0;
    let len = str.length;
    if (len % 2 != 0) {
        return null;
    }
    len /= 2;
    let arrBytes = new Array();
    for (let i = 0; i < len; i++) {
        let s = str.substr(pos, 2);
        let v = parseInt(s, 16);
        arrBytes.push(v);
        pos += 2;
    }
    return arrBytes;
}


/**
 * base64编码格式转为hex数据
 * @param {*} arrBytes
 * @returns
 */
export function bytes2HexString(arrBytes) {
    let str = "";
    for (let i = 0; i < arrBytes.length; i++) {
        let tmp;
        let num = arrBytes[i];
        if (num < 0) {
            //此处填坑，当byte因为符合位导致数值为负时候，需要对数据进行处理
            tmp = (255 + num + 1).toString(16);
        } else {
            tmp = num.toString(16);
        }
        if (tmp.length == 1) {
            tmp = "0" + tmp;
        }
        str += tmp;
    }
    return str;
}

export function createNonce() {
    let sum = "";
    for (let i = 0; i < 17; i++) {
        let item = Math.round(Math.random() * 10);
        sum += item;
    }
    return sum;
}


export function getTimestamp() {
    const date = new Date();
    const timestamp = date.getTime().toString();
    return timestamp;
}

export function getCommonRequestPrams(requestMethod, appKey) {
    let params = {
        method: requestMethod,
        appKey: appKey,
        nonce: createNonce(),
        params: "",
        timestamp: getTimestamp(),
        version: "1.0",
        signature: "",
    };

    return params;
}

export function signature(params, appSecret) {
    return sha256(
        "appKey" +
        params.appKey +
        "method" +
        params.method +
        "nonce" +
        params.nonce +
        "params" +
        params.params +
        "timestamp" +
        params.timestamp +
        "version" +
        params.version,
        appSecret
    ).toLowerCase();
}

export function parseWebsocketMsg(message, loginInfo, keyCode) {
    let {EncKey, EncLoad} = loginInfo;
    let key = CryptoJS.enc.Latin1.parse(EncKey);
    message = JSON.stringify(message);
    let encrypted = CryptoJS.AES.encrypt(message, key, {
        iv: CryptoJS.enc.Latin1.parse(EncLoad),
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
    });
    let data = hexString2Bytes(encrypted.ciphertext.toString());
    let b = new Uint8Array(data);
    let len = b.length;
    let aa = (len >> 8) & 0xff;
    let bb = len & 0xff;
    let a = [0x23, 0x24, keyCode.ii, keyCode.nn, aa, bb, 0x31, 0x00];
    let c = a.concat([...b]);
    let binary = new Uint8Array(c.length);
    for (let ii = 0; ii < c.length; ii++) {
        binary[ii] = c[ii];
    }

    return binary;
}

export function parseWebsocketBinaryMsg(typedArray, keyCode, isEncryption) {
    let len = typedArray.length;
    let aa = (len >> 8) & 0xff;
    let bb = len & 0xff;
    let a = [0x23, 0x24, keyCode.ii, keyCode.nn, aa, bb, isEncryption ? 0x31 : 0x00, 0x00];
    let c = a.concat([...typedArray]);
    let binary = new Uint8Array(c.length);
    for (let ii = 0; ii < c.length; ii++) {
        binary[ii] = c[ii];
    }

    return binary;
}


export function decryptDev(msg, env) {
    msg = bytes2HexString(msg);
    let key = CryptoJS.enc.Latin1.parse(env.EncKey);
    let iv = CryptoJS.enc.Latin1.parse(env.EncLoad);
    // AES解密
    let dec = CryptoJS.AES.decrypt(
        CryptoJS.format.Hex.parse(msg),
        key,
        {
            iv: iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7,
        }
    );
    return JSON.parse(CryptoJS.enc.Latin1.stringify(dec));
}

//
export function encryptTalkMsg() {

}

export function decryptView(msg, env) {
    msg = bytes2HexString(msg);
    let key = CryptoJS.enc.Latin1.parse(env.EncKey);
    let iv = CryptoJS.enc.Latin1.parse(env.EncLoad);

    let dec = CryptoJS.AES.decrypt(
        CryptoJS.format.Hex.parse(msg),
        key,
        {
            iv: iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.NoPadding,
        }
    );

    return dec;
}

export function encryptMediaParam(buf, aeskey, aesiv) {
    var param = Array.prototype.slice.call(new Uint8Array(buf));

    var data = new Array()
    var dataf = new Array()

    var len = buf.byteLength
    if (len >= 32) {
        data = param.slice(0, 32)
        dataf = param.slice(32)
    } else if (len < 32 && len >= 16) {
        data = param.slice(0, 16)
        dataf = param.slice(16)
    } else {
        return buf
    }

    var ab = new Uint8Array(data).buffer;

    var key = CryptoJS.enc.Latin1.parse(aeskey);
    var iv = CryptoJS.enc.Latin1.parse(aesiv);

    var str = String.fromCharCode.apply(null, new Uint8Array(ab))

    var encrypted = CryptoJS.AES.encrypt(str, key, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.ZeroPadding
    });


    var rsparr = new Array()

    for (let a of encrypted.ciphertext.words) {
        rsparr.push((a & 0xFF000000) >> 24)
        rsparr.push((a & 0x00FF0000) >> 16)
        rsparr.push((a & 0x0000FF00) >> 8)
        rsparr.push((a & 0x000000FF))
    }

    if (dataf.length > 0) {
        rsparr = rsparr.concat(dataf)
    }

    return new Uint8Array(rsparr);
}
